document.addEventListener("DOMContentLoaded", function () {

    const imgs = Array.from(document.querySelectorAll(".image-gallery img"));

    const shuffle = (array) => {
        let currentIndex = array.length;
        let temporaryValue = null;
        let randomIndex = null;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }

    const startFadeIn = elms => {
        const className = "js-fade-in";

        shuffle(elms).forEach((el, index) => {


            gsap.fromTo(el, {
                autoAlpha: 0,
                scale: 0.8,
            }, {
                autoAlpha: 1,
                scale: 1,
                delay: index === 0 ? 0 : index * 0.1,
                duration: 0.5,
                ease: "power1.out",
            });


        });
    };

    startFadeIn(imgs);

});